var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.option.attribute.decorationType,{key:_vm.refreshFlagKey,tag:"component",style:({width:_vm.width+'px',height:_vm.height+'px',color: _vm.option.attribute.textColor}),attrs:{"color":[_vm.option.attribute.color1, _vm.option.attribute.color2]}},[_vm._v(_vm._s(_vm.option.attribute.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }